import installation from './Installation'
import basicUsage from './BasicUsage'
import preConfiguration from './PreConfiguration'
import docs from './Docs'
import apiReference from './ApiReference'
import freeCustomize from './FreeCustomize'

export default {
  installation,
  basicUsage,
  preConfiguration,
  docs,
  apiReference,
  freeCustomize
}



// WEBPACK FOOTER //
// ./src/codes/VueApiRequestDemo/code.js